import {
  EnhancedTableHeader,
  EnhancedTableHeaderType
} from '@components/table/widgets/shared-with-old';
import { MAIN_THEME } from '@styles';

export const headers: Record<string, EnhancedTableHeader> = {
  name: {
    name: 'name',
    title: 'Name',
    type: EnhancedTableHeaderType.Link,
    urlTemplate: '/production/proposal/{id}',
    openUrlInNewTab: false
  },
  'line.code': {
    name: 'line.code',
    title: 'Line',
    type: EnhancedTableHeaderType.Text
  },
  'subline.code': {
    name: 'subline.code',
    title: 'Subline',
    type: EnhancedTableHeaderType.Text
  },
  'plan.code': {
    name: 'plan.code',
    title: 'Plan',
    type: EnhancedTableHeaderType.Text
  },
  ownerID: {
    name: 'ownerID',
    title: 'Owner',
    type: EnhancedTableHeaderType.Text,
    filterField: 'owner.person.fullName'
  },
  policyEffectiveDate: {
    name: 'policyEffectiveDate',
    title: 'Effective Date',
    type: EnhancedTableHeaderType.Date
  },
  mainBusinessPartner: {
    name: 'mainBusinessPartner',
    title: 'Main Broker',
    type: EnhancedTableHeaderType.Text,
    filterField: 'mainBusinessPartner.person.fullName'
  },
  policyType: {
    name: 'policyType',
    title: 'Policy Type',
    type: EnhancedTableHeaderType.Text
  },
  status: {
    name: 'status',
    title: 'Status',
    type: EnhancedTableHeaderType.ColoredText,
    textColorConfig: {
      New: MAIN_THEME.color.blue,
      'In Progress': MAIN_THEME.color.orange,
      'Closed Won': MAIN_THEME.color.green,
      'Closed Lost': MAIN_THEME.color.red
    }
  },
  createdOn: {
    name: 'createdOn',
    title: 'Created On',
    type: EnhancedTableHeaderType.Date
  }
};
